import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Link } from "react-router-dom";
import categories from "../data/categories";

/**
 * Onglets de catégories — même style que les onglets « Langage Naturel / Vision / … » de la page d'accueil
 * (TabCardGrid), mais ce sont des liens (chaque catégorie a sa propre URL).
 */

const Nav = tw.nav`flex flex-wrap justify-center lg:justify-start`;
const Tabs = tw.div`flex flex-wrap bg-gray-200 px-2 py-2 rounded leading-none`;

const Tab = styled(Link)(({ $active }) => [
  tw`px-5 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base text-center focus:outline-none focus:shadow-outline`,
  tw`hocus:bg-gray-300 hocus:text-gray-700`,
  $active && tw`bg-primary-500! text-gray-100!`,
]);

const Count = tw.span`ml-2 text-xs font-bold opacity-75`;

export default function CategoryTabs({ activeId = null, counts = null, showCounts = false, total = null }) {
  return (
    <Nav aria-label="Catégories du blog">
      <Tabs>
        <Tab to="/blog" $active={!activeId} aria-current={!activeId ? "page" : undefined}>
          Tous
          {showCounts && total != null && <Count>{total}</Count>}
        </Tab>
        {categories.map(category => {
          const active = category.id === activeId;
          const count = counts ? counts[category.id] : null;
          if (showCounts && counts && !count) return null; // pas d'onglet vide
          return (
            <Tab key={category.id} to={`/blog/categorie/${category.slug}`} $active={active} aria-current={active ? "page" : undefined}>
              {category.short || category.label}
              {showCounts && count != null && <Count>{count}</Count>}
            </Tab>
          );
        })}
      </Tabs>
    </Nav>
  );
}
